import { useState, useContext, useEffect } from 'react'
import { DataContext } from "../data/DataContext";
import { Input } from "./Input";
import { DropDown } from "./DropDown";
import { InputFile } from "./InputFile";
import { catIdentificationType } from "../data/MochaData";

const VehiclesInvolvedCtrl = ({ data }: IVehiclesInvolvedCtrlProps) => {

    const { ReclamosInspeccionNI, setReclamosInspeccionNI } = useContext(DataContext);
    const [vehicleInvolved, setVehicleInvolved] = useState(data)

    const change: any = (event: any) => {
        setVehicleInvolved({ ...vehicleInvolved, [event.target.name]: event.target.value });
    }

    const changeCbo = (properties: string, value: string) => {
        const prop = properties.split('_');
        setVehicleInvolved({ ...vehicleInvolved, [prop[0]]: value });
    }

    const changeFiles = (propierties: string, files: Array<File>) => {
        const prop = propierties.split('_');
        setVehicleInvolved({ ...vehicleInvolved, [prop[0]]: files });
    }

    useEffect(() => {
       // console.log(vehicleInvolved);
        update();
    }, [vehicleInvolved])



    const update = () => {
        let lst = ReclamosInspeccionNI.vehiclesInvolved;
        if (lst !== undefined && lst.length > 0) {
            let index = lst.findIndex(x => x.id === vehicleInvolved.id);
            if (index !== undefined) {
                lst[index].carPlate = vehicleInvolved.carPlate;
                lst[index].identificationType = vehicleInvolved.identificationType;
                lst[index].identification = vehicleInvolved.identification;
                lst[index].identificationFrontImage = vehicleInvolved.identificationFrontImage;
                lst[index].identificationBackImage = vehicleInvolved.identificationBackImage;
                lst[index].firstName1 = vehicleInvolved.firstName1;
                lst[index].firstName2 = vehicleInvolved.firstName2;
                lst[index].lastName1 = vehicleInvolved.lastName1;
                lst[index].lastName2 = vehicleInvolved.lastName2;
                lst[index].cellPhone = vehicleInvolved.cellPhone;
                lst[index].mail = vehicleInvolved.mail;
                lst[index].frontVehicleImage = vehicleInvolved.frontVehicleImage;
                lst[index].backVehicleImage = vehicleInvolved.backVehicleImage;
                lst[index].rightVehicleImage = vehicleInvolved.rightVehicleImage;
                lst[index].leftVehicleImage = vehicleInvolved.leftVehicleImage;
                lst[index].damageVehicleImage = vehicleInvolved.damageVehicleImage;
                setReclamosInspeccionNI({ ...ReclamosInspeccionNI, vehiclesInvolved: lst });
            }
        }
    }

    const remove = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.preventDefault();
        let lst = ReclamosInspeccionNI.vehiclesInvolved;
        let result = lst?.filter(x => x.id !== data.id);
        setReclamosInspeccionNI({ ...ReclamosInspeccionNI, vehiclesInvolved: result });
    }


    return (
        <>
          {data.id !== 1 &&
                <div className='mt-10' style={{ display: 'flex' }}>
                    <button className='btn-add-re-ni' style={{ background: "#D43C37" }} onClick={remove}> - </button>
                </div>
            }
            <Input
                id={`carPlate_${vehicleInvolved.id}`}
                field="carPlate"
                label="Placa del vehículo involucrado"
                value={vehicleInvolved.carPlate}
                onChange={change}
                isRequired={false}
            />

            <DropDown
                label='Tipo de identificación'
                id={`identificationType_${vehicleInvolved.id}`}
                field={`identificationType`}
                valueSelect={vehicleInvolved.identificationType}
                dataProvider={catIdentificationType}
                onChangeSelect={changeCbo}
                isRequired={false}
            />

            {vehicleInvolved.identificationType === '1' &&
                <Input
                    id={`identification_${vehicleInvolved.id}`}
                    field={`identification`}
                    onChange={change}
                    label='Número de identificación del conductor'
                    value={vehicleInvolved.identification}
                    type='mask'
                    mask="999-999999-9999a"
                    pattern="\d\d\d-\d\d\d\d\d\d-\d\d\d\d\w"
                    title="Documento invalido"
                    isRequired={false}
                />
            }
            {vehicleInvolved.identificationType !== '1'  &&
                <Input
                    id={`identification_${vehicleInvolved.id}`}
                    field={`identification`}
                    onChange={change}
                    label='Número de identificación del conductor'
                    value={vehicleInvolved.identification}
                    isRequired={false}
                />
            }

            <InputFile
                id={`identificationFrontImage_${vehicleInvolved.id}`}
                label='Fotografía de la parte delantera de la identificación'
                files={vehicleInvolved.identificationFrontImage}
                onChange={changeFiles}
                isRequired={false}
                maxFiles={1}
            />

            <InputFile
                id={`identificationBackImage_${vehicleInvolved.id}`}
                label='Fotografía de la parte trasera de la identificación'
                files={vehicleInvolved.identificationBackImage}
                onChange={changeFiles}
                isRequired={false}
                maxFiles={1}
            />

            <Input
                id={`firstName1_${vehicleInvolved.id}`}
                field='firstName1'
                onChange={change}
                label='Nombres'
                value={vehicleInvolved.firstName1}
                placeholder="Primer Nombre"
                isRequired={false}
            />
            <Input
                id={`firstName2_${vehicleInvolved.id}`}
                field='firstName2'
                onChange={change}
                label=''
                value={vehicleInvolved.firstName2}
                placeholder="Segundo Nombre"
                onlyInput={true}
                isRequired={false}
            />
            <Input
                id={`lastName1_${vehicleInvolved.id}`}
                field='lastName1'
                onChange={change}
                label='Apellidos'
                value={vehicleInvolved.lastName1}
                placeholder="Primer Apellido"
                isRequired={false}
            />
            <Input
                id={`lastName2_${vehicleInvolved.id}`}
                field='lastName2'
                onChange={change}
                label=''
                value={vehicleInvolved.lastName2}
                placeholder="Segundo Apellido"
                onlyInput={true}
                isRequired={false}
            />
            <Input
                id={`cellPhone_${vehicleInvolved.id}`}
                field='cellPhone'
                onChange={change}
                label='Celular'
                value={vehicleInvolved.cellPhone}
                placeholder="8888-8888"
                type='mask'
                mask="9999-9999"
                isRequired={false}
            />
            <Input
                id={`mail_${vehicleInvolved.id}`}
                field='mail'
                onChange={change}
                label='Correo electrónico'
                value={vehicleInvolved.mail}
                placeholder="Ejemplo: usuario@dominio.com"
                isRequired={false}
            />

            {/* <InputFile
                id={`frontVehicleImage_${vehicleInvolved.id}`}
                label='Fotografías a la parte delantera del vehículo'
                files={vehicleInvolved.frontVehicleImage}
                onChange={changeFiles}
                isRequired={false}
            />
            <InputFile
                id={`backVehicleImage_${vehicleInvolved.id}`}
                label='Fotografías a la parte trasera del vehículo'
                files={vehicleInvolved.backVehicleImage}
                onChange={changeFiles}
                isRequired={false}
            />
            <InputFile
                id={`rightVehicleImage_${vehicleInvolved.id}`}
                label='Fotografías al lateral derecho del vehículo'
                files={vehicleInvolved.rightVehicleImage}
                onChange={changeFiles}
                isRequired={false}
            />
            <InputFile
                id={`leftVehicleImage_${vehicleInvolved.id}`}
                label='Fotografías al lateral izquierdo del vehículo'
                files={vehicleInvolved.leftVehicleImage}
                onChange={changeFiles}
                isRequired={false}
            /> */}
            <InputFile
                id={`damageVehicleImage_${vehicleInvolved.id}`}
                label='Fotografías de los daños del vehículo'
                files={vehicleInvolved.damageVehicleImage}
                onChange={changeFiles}
                isRequired={false}
                maxFiles={5}
            />
        </>
    );

}

export { VehiclesInvolvedCtrl }